import React, { useContext, useEffect } from "react";
import useState from "react-usestateref";
import { Link, useNavigate, useLocation } from "react-router-dom";
import authService from "../services/authservices";
import { UserContext } from "../contexts/UserContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import i18n from "../translate/i18n";

function EmailVerify() {
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);

  const [verificationCode, setVerificationCode] = useState("");
  const [otpSent, setOtpSent] = useState(
    sessionStorage.getItem("timerstatus") == "true" ? true : false
  );
  const [timer, setTimer] = useState(60); // Start with 60 seconds
  const [signloader, setSignloader] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  // console.log(otpSent, "otpSent");

  const sendOtp = async () => {
    try {
      setOtpSent(true);
      setTimer(60); // Start the timer at 60 seconds
      sessionStorage.setItem("timerstatus", "true");
      // var timeStatus = sessionStorage.getItem("timerstatus");
      const response = await authService.resendOtp({ email: user.email });
      if (response.data.status) {
        setVerificationCode("");
        showsuccessToast(
          <div className="toast-ml">
            <h4 className="toast-title">Success!</h4>
            <p className="toast-message">OTP resent successfully!</p>
          </div>
        );
      } else {
        sessionStorage.setItem("timerstatus", "false");
        setVerificationCode("");
        showerrorToast(
          // response.data.Message || "Failed to resend OTP. Please try again."

          <div className="toast-ml">
            <h4 className="toast-title">Error!</h4>
            <p className="toast-message">
              {response.data.Message ||
                "Failed to resend OTP. Please try again."}
            </p>
          </div>
        );
        setOtpSent(false);
      }
    } catch (error) {
      setVerificationCode("");
      // console.error("Error during OTP resend:", error);
      sessionStorage.setItem("timerstatus", "false");
      showerrorToast(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">An error occurred. Please try again.</p>
        </div>
      );
      setOtpSent(false);
    }
  };

  // useEffect(() => {
  //   // Reset "timerstatus" to false on page load
  //   if (sessionStorage.getItem("timerstatus") === "true") {
  //     sessionStorage.setItem("timerstatus", "false");
  //   }
  // }, [])
  useEffect(() => {
    var email = user.email ? user.email : localStorage.getItem("useremail");
    if (!email || email == null || email == undefined) {
      navigate("/register");
    }
    // setOtpSent(sessionStorage.getItem("timerstatus")=='true'?false:false);
    let countdown;
    if (timer > 0 && otpSent) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setOtpSent(false);
      clearInterval(countdown);
      sessionStorage.setItem("timerstatus", true);
    }
    return () => clearInterval(countdown);
  }, [timer, otpSent]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (value.length <= 6 && /^[0-9]*$/.test(value)) {
      setVerificationCode(value);
    }
    if (error) {
      setError("");
    }
  };

  useEffect(() => {
    // Push a dummy state to the history stack
    window.history.pushState(null, null, window.location.href);

    const preventNavigation = () => {
      // Push the state again to prevent navigation
      window.history.pushState(null, null, window.location.href);
    };

    // Listen for the popstate event (triggered by back/forward navigation)
    window.addEventListener("popstate", preventNavigation);

    return () => {
      // Clean up the event listener
      window.removeEventListener("popstate", preventNavigation);
    };
  }, []);

  const handleKeyDown = (e) => {
    // Allow only numbers, Backspace, and Ctrl+V
    const allowedKeys = [
      "Backspace",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
      "Tab",
    ]; // Allow navigation keys and Backspace

    if (
      !/[0-9]/.test(e.key) && // Restrict non-numeric keys
      !allowedKeys.includes(e.key) && // Allow specific keys
      !(e.ctrlKey && e.key === "v") // Allow Ctrl+V for paste
    ) {
      e.preventDefault();
    }
  };

  const handleSubmitNew = async (e) => {
    const value = e.target.value;
    e.preventDefault();
    if (!verificationCode) {
      setError("OTP is required");
      return;
    }
    if (/^\d*$/.test(value)) {
      setVerificationCode(value);
      if (error) {
        setError("");
      }
    }
    try {
      setSignloader(true);
      // console.log(user.email, "user.email  user", user);

      const response = await authService.verifyOtp({
        email: user.email ? user.email : localStorage.getItem("useremail"),
        emailOtp: Number(verificationCode),
      });
      setSignloader(false);
      // console.log("response-->>", response);
      if (response.status) {
        showsuccessToast(
          <div className="toast-ml">
            <h4 className="toast-title">Success!</h4>
            <p className="toast-message">
              OTP verified successfully ! Login to continue
            </p>
          </div>
        );
        // setTimeout(() => {
        navigate("/login");
        // }, 3000);
      } else {
        showerrorToast(
          <div className="toast-ml">
            <h4 className="toast-title">Error!</h4>
            <p className="toast-message">{response.Message}</p>
          </div>
        );
      }
    } catch (error) {
      setSignloader(false);
      // console.error("Error during OTP verification:", error);
      setError("An error occurred. Please try again.");
    }
  };

  const showsuccessToast = (message) => {
    toast.dismiss();
    toast.success(message);
  };

  const showerrorToast = (message) => {
    toast.dismiss();
    toast.error(message);
  };

  return (
    <div>
      <div className="row register_main container-fluid">
        <div className="col-lg-6">
          <div className="d-flex flex-column mb-5">
            <div className="register_head_logo">
              <Link to="/">
                <img
                  src={require("../assests/Logo.webp")}
                  alt="Logo"
                  className="register_logo cursor-pointer"
                />
              </Link>
            </div>
            <div className="register_left_main mt-4">
              <div className="hero_center">
                <div className="register_form">
                  <span className="register_head_sign">
                    {" "}
                    {t("EmailVerify")}{" "}
                  </span>
                  <div className="register_inner_main">
                    <div className="getting_card_content w-100">
                      <div className="register_inner_submain w-100">
                        <div className="reg_inner_small">
                          <span className="register_spans">
                            {t("EmailCode")}
                          </span>
                          <div className="reg_pos_rel">
                            <input
                              type="number"
                              name="emailOtp"
                              placeholder={t("EnterTheVerificationCode")}
                              className="reg_input email_padding_resp"
                              value={verificationCode}
                              onChange={handleInputChange}
                              onKeyDown={handleKeyDown}
                            />

                            {sessionStorage.getItem("timerstatus") ==
                            "false" ? (
                              ""
                            ) : otpSent ? (
                              <span className="pos_abs_resend">
                                {t("Resend")}{" "}
                                {sessionStorage.getItem("timerstatus") == "true"
                                  ? `${timer}s`
                                  : ""}
                              </span>
                            ) : (
                              <span
                                className="pos_abs_resend"
                                onClick={sendOtp}
                                style={{ cursor: "pointer" }}
                              >
                                {t("Resend")}
                              </span>
                            )}
                          </div>

                          {error && <span className="error">{error}</span>}
                        </div>
                      </div>
                    </div>
                    <div className="getting_card_content">
                      {signloader === true ? (
                        <div className="reg_btn">
                          <span className="hero_invest"> {t("Loading")} </span>
                        </div>
                      ) : (
                        <div className="reg_btn" onClick={handleSubmitNew}>
                          <span className="hero_invest"> {t("Verify")} </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <span className="reg_bottom_span">
                  <Link to="/register">
                    {" "}
                    <span className="reg_check_span">
                      {t("BackToSignUp.")}
                    </span>{" "}
                  </Link>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 emailverify_right_main">
          <div className="login_right">
            <div className="footer_links_div">
              <span className="register_head"> {t("VerifyYourEmail")}</span>
              <span className="register_subhead">
                {t("verificationCode")}
                <br /> {t("AddressYouHaveEntered")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmailVerify;
